// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"a7a5511e","87":"63e07eab","348":"ce444b0f","367":"35de156a","431":"3bf3f208","488":"c045f809","522":"87fc7aee","575":"bfeecd71","617":"ae7dabe0","673":"aebfe827","795":"29bd2474","805":"05222b1e","913":"dc7e3ef2","927":"b9b0d29e"}[chunkId] + ".chunk.js";
};